/**
 * Common messages - 简体中文
 * 公共文案 - 中文（默认/回退）
 */
export default {
  // Actions
  confirm: '确定',
  cancel: '取消',
  save: '保存',
  submit: '提交',
  delete: '删除',
  edit: '编辑',
  add: '新增',
  search: '查询',
  reset: '重置',
  collapse: '收起',
  expand: '展开',
  clearFilter: '清除筛选',
  startDate: '开始日期',
  endDate: '结束日期',
  placeholderSelectQuarter: '请选择季度',
  yearUnit: '年',
  quarterUnit: '季度',
  quarter1: '第1季度',
  quarter2: '第2季度',
  quarter3: '第3季度',
  quarter4: '第4季度',
  prevYear: '前一年',
  nextYear: '后一年',
  yearQuarterFormat: '{year}年{quarter}季度',
  thisWeek: '本周',
  thisMonth: '本月',
  lastWeek: '上周',
  lastMonth: '上月',
  pleaseFillRequired: '请填写必填字段！',
  requiredField: '此项必填',
  placeholderAgentArea: '请选择代理商所属区域',
  export: '导出',
  import: '导入',
  back: '返回',
  close: '关闭',
  view: '查看',
  more: '更多',
  copy: '复制',
  copySuccess: '复制成功',
  unbound: '未绑定',
  normal: '正常',
  disabled: '禁用',
  pin: '置顶',
  primary: '主',
  bindMobileTip: '绑定手机号后，可使用该手机号登录系统及找回密码',
  accountPendingConfirmTip: '账号创建后，账号的状态是"待确认"，"待确认"的账号无法登录。创建的同时员工会收到总部钉钉加入的邀请，下载并打开钉钉，接受邀请加入总部后，账号就会从"待确认"变为"正常"状态，即可登录系统。',
  planningDept: '统筹部',
  classHours: '课时',
  classHoursFormat: '{hours}课时',
  selectPayTimeRequired: '请选择支付时间',
  confirmRemoveFile: '确定移除 {fileName}？',
  consider: '考虑一下',
  pay: '支付',
  payment: '支付',

  // Status / tips
  loading: '加载中...',
  success: '成功',
  failed: '失败',
  noData: '暂无数据',
  operationSuccess: '操作成功',
  operationFailed: '操作失败',
  cancelSuccess: '取消成功',
  cancelFailed: '取消失败',
  cancelDelete: '已取消删除',
  deleteSuccess: '删除成功',
  systemErrorRetryLater: '系统异常，请稍后重试',

  // Form
  pleaseInput: '请输入',
  pleaseSelect: '请选择',
  placeholderFilterKeyword: '请输入关键字过滤',
  placeholderSelectUser: '请选择用户',
  selectAll: '全选',

  // Table
  index: '序号',
  operation: '操作',
  remark: '备注',
  fileName: '文件名',
  fileSize: '大小',
  fileStatus: '文件状态',
  operator: '操作人',
  operateTime: '操作时间',
  createTime: '创建时间',
  updateTime: '更新时间',

  // Pagination
  total: '共',
  page: '页',
  pageSize: '每页条数',
  goto: '前往',
  itemsPerPage: '条/页',
  switch: '切换',
  helpCenter: '帮助中心',
  readDone: '已阅读',
  passwordUpdateHint: '为保证账户安全，请及时更新密码',
  oldPasswordLabel: '原密码：',
  placeholderOldPassword: '请输入原密码',
  newPasswordLabel: '新密码：',
  placeholderNewPassword: '请输入新密码',
  confirmPasswordLabel: '确认新密码：',
  placeholderConfirmPassword: '请确认新密码',
  rulePasswordMismatch: '两次新密码输入不一致',
  ruleReenterNewPassword: '请重新输入新密码',
  ruleEnterOldPassword: '请输入原密码',
  ruleEnterNewPassword: '请输入新密码',
  ruleReenterNewPasswordForConfirm: '请再次输入新密码',

  // Login
  loginTitle: '智能硬件代理商管理系统',
  passwordLogin: '密码登录',
  codeLogin: '验证码登录',
  phoneVerify: '手机验证',
  phoneLabel: '手机号：',
  placeholderPhone: '请输入手机号',
  changeVerifyPhone: '更换验证手机',
  verifyCodeLabel: '验证码：',
  placeholderVerifyCode: '请输入验证码',
  getVerifyCode: '获取验证码',
  resendAfter: 's后重新获取',
  resendVerifyCode: '重新获取验证码',
  placeholderUsernameOrPhone: '请输入用户名/手机号',
  placeholderPassword: '请输入密码',
  forgotPassword: '忘记密码',
  login: '登录',
  recoverPassword: '找回密码',
  recoverPasswordTip: '使用账号绑定的手机号找回密码',
  verifyCodePlaceholder: '验证码',
  ruleUsernameRequired: '请输入用户名/手机号',
  rulePasswordRequired: '请输入密码',
  ruleValidPhone: '请输入有效的手机号',
  ruleVerifyCodeRequired: '请输入验证码',
  ruleNewPasswordRequired: '请输入新密码',
  verifyCodeSuccess: '验证码发送成功',
  verifyCodeFailed: '验证码发送失败',
  passwordResetSuccess: '密码重置成功, 请使用新密码登录',
  passwordResetFailed: '密码重置失败',
  confirmClose: '确认关闭？',
  loginAccountLabel: '登陆账号：',
  placeholderLoginAccount: '请输入登陆账号',
  oldPhoneLabel: '原手机号：',
  newPhoneLabel: '新手机号：',
  placeholderNewPhone: '请输入新手机号',
  enterOldPhoneRequired: '请输入原手机号',
  enterNewPhoneRequired: '请输入新手机号',
  verifyCodeError: '验证码错误',
  phoneVerifyTitle: '手机验证',
  resendAfterSend: 's后重新发送',
  prevAgentLevelCycle: '前期代理级别权益周期：',
  currentAgentLevelCycle: '当前代理级别权益周期：',
  totalPaidOrderAmount: '累计完款订单金额：',
  yuanUnit: '元',
  unitTai: '台',
  bindMobile: '绑定手机',
  accountUpgradeMsg: '您的账号已经升级为松鼠Ai账号，请从统一登录平台登录',
  changeVerifyPhoneTitle: '更换验证手机号-身份验证',
  changePhoneBindTitle: '更换手机号-绑定新手机号',
  enterPhoneRequired: '请输入手机号',
  verifyCodeSentSuccess: '验证码发送成功，请在手机上查看！',
  enterVerifyCodeRequired: '请输入验证码',
  loginFailed: '登录失败',
  verifySuccess: '验证成功',
  nextStep: '下一步',

  // Home / layout
  accountSecurityCenter: '账号安全中心',
  exportDownload: '导出下载',
  closeSystem: '关闭系统',
  modifyPassword: '修改密码',
  logout: '退出登录',
  headquarterNotice: '总部通知',
  viewDetail: '查看详情',
  targetSettingReminder: '目标设定提醒',
  remindMeLater: '稍后再说',
  goToSet: '前往设定',
  newAnnouncementTitle: '您有一条新的公告消息',
  emergencyTag: '【紧急】',
  viewLater: '一会再看',
  viewNow: '立即查看',
  importantTag: '【重要】',
  requestFailed: '请求失败',
  verifyFailed: '验证失败！',
  passwordChangeSuccess: '密码修改成功, 请使用新密码登录',
  passwordChangeFailed: '密码修改失败',
  creditOrderPaymentRequirement: '赊货订单付款要求',
  creditOrderTailPaymentDesc: '经销商销售设备激活回款后，需要支付赊货订单的尾款，',
  doubleOrderHelpDesc: '双重订单是省代关联本省代理商、经销商的账户现金，实现集中备货的采购订单。具体规则详见：',
  warehousePickupHelpDesc: '仓内提货是通过代理商系统将自己京东云仓库存设备提货到线下门店，具体操作详见:',
  loanReturnHelpDesc: '仓间借还货允许开通京东云仓的代理商和合作代理商在同一个京东云仓内进行借还货的操作，具体操作详见：',
  agentAccountFaq: '代理商账户常见问题：',
  referralAndChannel: '转介绍及渠道代',
  creditOrder: '赊货订单',
  creditOrderHelpIntro: '为了帮助经销商快速发展',
  orderRequirementTitle: '下单要求',
  creditOrderRequirementDesc: '经销商可以向上级代理商提交赊货订单',
  orderProcessTitle: '下单流程',
  orderProcessDesc1: '需要代理商审核通过后订单生效',
  orderProcessDesc2: '代理商发货后，SN流转到经销商名下',
  systemUsageRestricted: '您的系统使用已被限制。限制原因：',
  restrictionReason: '限制原因',
  helpCardReferralReward: '关于转介绍客户首笔合同款奖励的计算规则和查询，请参阅帮助中心；',
  helpCardRegionCustomers: '关于区域内转介绍客户的查询，请参阅帮助中心；',
  helpCardRebatesFees: '关于渠道代的返佣和服务费奖励的计算规则和查询，请参阅帮助中心；',

  // AdvertiseMessage 公告消息
  setEmergencyContact: '设置紧急联系人',
  emergencyContactSetting: '紧急联系人设置',
  emergencyContactTip1: '为避免您错过总部的紧急重要通知（如核心政策），系统建议您为您的组织设置最多2位紧急联系人专门用于接收此类通知并在团队内部传达。',
  emergencyContactTip2: '注意：被设置为"紧急联系人"的账号将在极少数（一般一个月不超过3次）的情况下接收总部电话+信息形式的通知，请提醒被设置人员注意接收电话。',
  selectStaff: '选择员工',
  placeholderSelectStaff: '请选择员工',
  emergencyContact1: '紧急联系人1',
  emergencyContact2: '紧急联系人2',
  notSet: '未设置',
  emergencyContactDescription: '无需设置紧急联系人？点击右侧按钮取消提醒',
  submitSuccess: '提交成功',
  submitFailed: '提交失败',
  getEmergencyContactFailed: '获取紧急联系人列表失败',
  // Common table columns
  sequence: '序列',
  name: '姓名',
  phoneNumber: '手机号',
  dingTalkNumber: '钉钉号',
  viewDetail: '查看详情',
  downloadAttachment: '下载附件',
  objectionContent: '异议内容',
  viewObjectionTitle: '查看异议内容',
  objectionLabel: '异议内容：',
  placeholderObjection: '请你填写您关于公告的内容',
  noAttachment: '该公告下无附件',
  noticeTitle: '公告标题',
  placeholderNoticeTitle: '请输入公告标题',
  noticeType: '公告类型',
  placeholderNoticeType: '请选择公告类型',
  urgencyLevel: '重要度',
  placeholderUrgency: '请选择重要度',
  noticeStatus: '状态',
  placeholderNoticeStatus: '请选择状态',
  sendTimeLabel: '发送时间：',
  noticeTitleCol: '公告标题',
  noticeTypeNameCol: '公告类型',
  urgencyLevelNameCol: '重要度',
  readStatusNameCol: '状态',
  sendTimeCol: '发送时间',
  readTimeCol: '已读时间',
  download: '下载',
  rangeTo: '至',

  // 导出组件
  exportTip: '提示',
  exportSubmitSuccess: '导出任务提交成功',
  exportGoToPrefix: '请前往',
  exportGoToSuffix: '进行下载',
  importExport: '导入导出',
  notNow: '暂不前往',
  goToExportDownload: '前往导出下载',
  exportApiRequired: '请传入接口路径',
  refreshStatus: '刷新状态',
  confirmDeleteFile: '确定删除{fileName}文件吗？',
  downloadFailed: '下载失败',
  exportFailed: '导出失败',
  systemErrorContactAdmin: '系统异常，请联系管理员',
  fetchDataFailed: '获取数据失败',

  // 账号冻结 / 唤醒（WakeDialog）
  wakeFreezeIntro: '您当前登录的松鼠Ai账号由于长时间未登录存在安全风险，已进入冻结状态，如需继续使用您可进行账号唤醒操作。',
  wakeNotLoginNow: '暂不登录',
  wakeActivateNow: '立即唤醒',
  wakeSecondIntro: '您ID{campusId}下的松鼠Ai账号正在被唤醒，请前往{phone}注册的钉钉同意团队邀请确认加入总部。',
  wakeDefer: '暂不处理',
  wakeConfirmed: '已确认',
  wakeAccountDisabled: '您的账号已禁用，请联系您的上级协调处理',
  wakeSuccess: '唤醒成功',
  wakeFailedRetry: '唤醒失败，请稍后重试',
};
